export const loginUrl = "/api/v3/auth/token";
export const resetPasswordUrl = "/api/v3/auth/passwd_reset/:token";
export const changePasswordUrl = "/api/v1/user/:userId/account/password";
export const forgotPasswordUrl =
  "/api/v3/auth/passwd_reset?userEmail=:userEmail";
